import React from 'react';
import { StyledLoginLayoutWrapper } from './styles';

const LoginLayout: React.FC = ({ children }) => (
  <StyledLoginLayoutWrapper>{children}</StyledLoginLayoutWrapper>
);

export default LoginLayout;
